// src/utils/media.ts
import type attachment from '@/models/attachment'

export type AttachmentModel = ReturnType<typeof attachment>

export type MediaResult =
  | {
      type: 'image'
      url: string
      alt?: string
      sizes?: AttachmentModel['sizes']
    }
  | {
      type: 'video'
      url: string
      poster?: string
    }

/**
 * Find attachment by ID
 */
export function getMediaById(
  attachments: AttachmentModel[],
  id?: number | null,
): AttachmentModel | undefined {
  if (!id) return undefined
  return attachments.find((a) => a.id === id)
}

/**
 * Normalize attachment -> media
 */
export function normalizeMedia(
  attachment?: AttachmentModel,
  imageSize = 'full',
): MediaResult | undefined {
  if (!attachment) return undefined

  // Video
  if (attachment.type === 'video') {
    return {
      type: 'video',
      url: attachment.sizes?.full?.source_url ?? '',
      poster: attachment.sizes?.poster?.source_url,
    }
  }

  // Image (default)
  const img =
    attachment.sizes?.[imageSize] ??
    attachment.sizes?.full

  if (!img?.source_url) return undefined

  return {
    type: 'image',
    url: img.source_url,
    alt: attachment.alt,
    sizes: attachment.sizes,
  }
}
